export function dataTrack(eventId?: string, info?: { [key: string]: any }) {
  if (!eventId) return;
  window.DATracker?.track?.(eventId, info);
}
